import { ErrorHandler, Injectable } from '@angular/core';

import { datadogRum } from '@datadog/browser-rum';

import { environment } from '../../../environments/environment';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    if (!environment.production) {
      console.error('[GlobalErrorHandler]', error);
      return;
    }

    // Production: send error to Datadog RUM
    if (error instanceof Error) {
      datadogRum.addError(error);
    } else {
      datadogRum.addError(new Error(String(error)));
    }
  }
}
